import { DialogRef } from '@angular/cdk/dialog';
import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SponsorCourseCardComponent } from '@cpd-app/core-module/components/sponsor-course-card/sponsor-course-card.component';
import { FEATURE_PATHWAYS } from '@cpd-app/core-module/constants/pathway-courses.const';
import { environment } from '@cpd-app/environment';
import {
  PathwayPageUsageCategoryEnum,
  SponsorshipCompany
} from '@cpd-app/generated';
import { ButtonModule } from '@cpd-app/shared-module/components/button/button.module';
import { TrackerFacade } from '@cpd-app/state/tracker';
import { get } from 'lodash';

@Component({
  templateUrl: './sponsored-training-banner-dialog.component.html',
  styleUrls: ['./sponsored-training-banner-dialog.component.scss'],
  standalone: true,
  imports: [
    ButtonModule,
    MatIcon,
    NgOptimizedImage,
    SponsorCourseCardComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsoredTrainingBannerDialogComponent {
  private readonly pathwayId = this.data.pathwayId;
  private readonly pathwayItem = environment.mxdSponsorMapping.find(
    (course) => course.id === this.pathwayId
  );

  public readonly sponsor = this.data.sponsor;
  public readonly pathwayFeatures = get(
    FEATURE_PATHWAYS,
    this.pathwayItem?.name,
    []
  );

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private readonly data: {
      sponsor: SponsorshipCompany;
      pathwayId: string;
    },
    private readonly dialogRef: DialogRef,
    private readonly trackerFacade: TrackerFacade
  ) {}

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public openExternalPage(): void {
    window.open(environment.mxdSignUpLink, '_blank');

    this.trackerFacade.savePathwayPageUsage({
      category: PathwayPageUsageCategoryEnum.ExternalTrainingLink,
      pathwayid: this.pathwayId
    });
  }
}
